__turbopack_context__.v({
  "buttonActions": "yg4qAG_buttonActions",
  "card": "yg4qAG_card",
  "footer": "yg4qAG_footer",
  "footerInner": "yg4qAG_footerInner",
  "header": "yg4qAG_header",
  "newSlot": "yg4qAG_newSlot",
  "overline": "yg4qAG_overline",
  "price": "yg4qAG_price",
  "priceBlock": "yg4qAG_priceBlock",
  "titleBlock": "yg4qAG_titleBlock",
});
